import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Card, Button, Space, Typography } from 'antd';
import { LoginOutlined, SafetyOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const LoginButton: React.FC = () => {
  const { loginWithRedirect, isLoading } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname
      }
    });
  };

  return (
    <Card className="login-card" bordered={false}>
      <Space direction="vertical" size="large" className="login-content">
        <div className="login-header">
          <SafetyOutlined className="login-icon" />
          <Title level={2} className="login-title">
            Welcome to EUDR Knowledge Agent
          </Title>
          <Paragraph className="login-subtitle">
            Your intelligent compliance companion for the EU Deforestation Regulation
          </Paragraph>
        </div>

        <div className="login-features">
          <Space direction="vertical" size="small">
            <div className="feature">
              🌱 <span>Comprehensive EUDR guidance</span>
            </div>
            <div className="feature">
              📚 <span>Up-to-date regulatory information</span>
            </div>
            <div className="feature">
              💬 <span>Interactive Q&A support</span>
            </div>
            <div className="feature">
              📄 <span>Document analysis and insights</span>
            </div>
          </Space>
        </div>

        <Button
          type="primary"
          size="large"
          icon={<LoginOutlined />}
          onClick={handleLogin}
          loading={isLoading}
          className="login-button"
          block
        >
          {isLoading ? 'Signing In...' : 'Sign In with Agridence ID'}
        </Button>
      </Space>
    </Card>
  );
};

export default LoginButton;